import React, { useState } from "react";
import { Grid } from "basis";
import {
  Container,
  FormattedPrice,
  Input,
  Label,
  RangeSlider,
  Text,
} from "../../../components";
import styled from "styled-components";
import { COLOR } from "../../../components/theme";
import { Box } from '@chakra-ui/react'

const InputContainer = styled.div`
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield;
  }
`;

const RowContainer = styled.div`
  inline-size: 100px;
  overflow-wrap: break-word;
  font-size: 15px;
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 16px;
`;

export const PointSelection = ({
  disabled = false,
  min,
  max,
  value,
  remainingAmount,
  onChange = () => {},
  validate = () => {},
}) => {
  const [enteredPoints, setEnteredPoints] = useState(value);

  const handleOnChange = ({ value }) => {
    setEnteredPoints(value);
    let val = Number(value);
    onChange(val);
  };

  const handleOnBlur = (e) => {
    let val = Number(e.target.value);
    let isValid = onChange(val);
    if (isValid) {
      setEnteredPoints(val);
    }
  };
  const handleSilder = (value) => {
    onChange(value);
    setEnteredPoints(value);
  };

  return (
    <>
      <Container>
        <Text textStyle="heading5" margin="8 0 2" color={COLOR.BLACK}>
          Pay with points
        </Text>

        <Text color="grey.t75" margin="0 0 4">
          A minimum of {min} pts are required to continue
        </Text>
      </Container>

      <Container margin="4 0 0">
        <Grid preset="page" rowsGap={8}>
          <Grid.Item colSpan="all">
            <RowContainer placeItems="center">
              <InputContainer>
                <Input
                  type="number"
                  label="Points"
                  value={enteredPoints}
                  disabled={disabled}
                  validate={validate}
                  onChange={handleOnChange}
                  onBlur={handleOnBlur}
                  borderWidth={1}
                  mt={8}
                  textColor={COLOR.BLACK}
                  fontFamily="LatitudeSans"
                  placeholderColor={COLOR.NEUTRAL_700}
                  fontWeightLabel={600}
                  backgroundColor="transparent"
                />
              </InputContainer>
              <Box alignSelf="flex-end" pb={1}>
                <Text
                  color={COLOR.HIGHLIGHT_BLUE}
                  textStyle="heading3"
                  fontFamily="LatitudeSans"
                >
                  +
                </Text>
              </Box>
              <Label
                title="Pay"
                fontFamily="LatitudeSans"
                fontWeight={600}
                fontSize={16}
              >
                <Box pt={5}>
                  <FormattedPrice
                    price={remainingAmount}
                    fontFamily="LatitudeSans"
                  />
                </Box>
              </Label>
            </RowContainer>
          </Grid.Item>
        </Grid>
      </Container>

      <RangeSlider
        min={min}
        max={max}
        step={50}
        value={value}
        disabled={disabled}
        onChange={handleSilder}
      />
    </>
  );
};
